import _ from 'lodash'
import { DS_setData } from '../DS/DS.Data'

export const Evnt_onResize = _.debounce(function () {
    DS_setData('screenResize', () => ({
        screenWidth: window.innerWidth,
    }))
}, 400)
